import EditModalComponent from "./EditModalComponent";
import React from "react";
import { Dialog, Box, Button } from "@mui/material";

const EditInventory = (props) => {
  const { data } = props;
  const [EditModal, setEditModal] = React.useState(false);
  const handleEditModal = () => {
    setEditModal(true);
  };
  return (
    <>
      <Button
        variant="outlined"
        onClick={handleEditModal}
        className="text-white border-0 px-6 py-2 focus:outline-none rounded cursor-pointer w-[100px] bg-slate-500 hover:bg-slate-700"
      >
        Edit
      </Button>
      <Dialog
        open={EditModal}
        onClose={() => setEditModal(false)}
        sx={{
          "& .MuiDialog-paper": {
            width: "800px",
            margin: "auto",
            borderRadius: 0,
            padding: "1rem",
          },
        }}
      >
        <Box>
          <EditModalComponent
            handleCloseModal={() => setEditModal(false)}
            data={data}
          />
        </Box>
      </Dialog>
    </>
  );
};

export default EditInventory;
